/**
 * 回答登録時の制限
 * - ボタンの回答はLINEは35文字まで
 * - その他のプラットフォームは1000文字まで
 */
const ANSWER_LIMITATIONS = {
  // カルーセルオプションとクイックリプライのボタン
  button: {
    maxLength: {
      // API仕様に基づく制限。
      LINE: 35,
      // 実際にはFBなどはAPIの仕様にあわせるべきだが現状はWebChatV2と同じ制限を利用
      OTHERS: 1000,
    },
  },
  // カードのボタン
  cardButton: {
    maxLength: {
      LINE: 20,
      OTHERS: 1000
    }
  }
};

export { ANSWER_LIMITATIONS };
